import React from 'react';

const Idara = () => {
    const departments = [
        {
            id: 2,
            name: "Uinjilisti na Umisheni",
            image: "https://lh3.googleusercontent.com/aida-public/AB6AXuAapCBK12h0qFeAloSO4mSfDqp3GCq2FW-KiHNQggaGqXDdBl0M8lZvEQFxNtUBfzLlOTdKL2xQ23lyg6DgBlvUi-q-bdJz61vAfQsfRE2_jRR22bzUq_1scsGKgBQu4rEA4i7IL4dtDxpN3fL_nFcBEWAx7kZDqyO6FqOmrJk2GznVsftJ_t8PJePEALPiaLTe2fjZPDAHdOInYOHENhb8rQoiQn2yNmlFyrtXYyGMPzxql-Q3A92fV2MnJWwgr5q78tjZw5002A"
        },
        {
            id: 3,
            name: "Teolojia",
            image: "https://lh3.googleusercontent.com/aida-public/AB6AXuC2_1OXJzegiK2F_3geu8XCkwRx5fgtVYyT7hw3dbzosU834WGNrn0GymrBSLie3PLX-nOM3zE2CMCN3MdiWU7GyewCMNZuZlTtdOfLzv-GWar81dRXOva4vCyRQs-mxtM-p1Rw8uDOjyH1X81FQgwz8Y2zN-Mw7ejYOOlT8hE-i0vSmMn7vokNWBozL86oJr6XWkZZ4MmpFzD2dQL4kTuCEgvN33q2PE_VC4rV1blspMeWc1LxxkAn1kwa4CYefwLFRDyM6Kgs0A"
        },
        {
            id: 4,
            name: "Elimu na Mafunzo",
            image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCppQLM4k6OHp36uMmokjMvZne2P_71_Pfe7jJ8XQmVz1PdbpIOoqPmm2tpltDzvJOSmG_LiZlYfe9naChQYCtdkEN1NS2Eo1KqlRqWcvldJR6H8yEt2L6v4s-ek-r5dR3Zp3m_Q6hSGkHU4DgCzTsoUREpJCbKjhfnNIB_rDDh2zPUPQYVPlvrQwaLFH0L1O0xvARuiFCuhtd0ZNTUheJQE3FPFSP3KMf8EizEgP4x2R8z-w4ZK1yxYLJ5idLQ9bwE08gwesuEow"
        },
        {
            id: 5,
            name: "Huduma za Jamii na Miradi ya Maendeleo",
            image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDx6eKccpV24Ps27vqIfZDPIoJDIqndvkXihKFnpWHbA9XrrUKZsv9y4YAhn2fnLZj3yIy8k_v5as9c66841_aKH5juF12KTiGfVsRndjT_khVT5qdB_rLA73mFx4YNRCXEuJK3jH1CzdgYcPmfyU3NcjoOvSpVEK6OXkfwPDI7FR0o410dTXl-QW-uIs-Y-ryKQwr_kJIWzrOneHZjjKy5f79kz0vPxnh3yxGkB57LwxxN8kdQKrYkD2cLdOFWQg4mwBewNid9Dg"
        }

    ];


    const vitengo = [
        {
            id: 2,
            name: "Masuala ya Kimataifa",
            image: "https://lh3.googleusercontent.com/aida-public/AB6AXuAapCBK12h0qFeAloSO4mSfDqp3GCq2FW-KiHNQggaGqXDdBl0M8lZvEQFxNtUBfzLlOTdKL2xQ23lyg6DgBlvUi-q-bdJz61vAfQsfRE2_jRR22bzUq_1scsGKgBQu4rEA4i7IL4dtDxpN3fL_nFcBEWAx7kZDqyO6FqOmrJk2GznVsftJ_t8PJePEALPiaLTe2fjZPDAHdOInYOHENhb8rQoiQn2yNmlFyrtXYyGMPzxql-Q3A92fV2MnJWwgr5q78tjZw5002A"
        },
        {
            id: 3,
            name: "Habari, Utangazaji, na Uchapaji",
            image: "https://lh3.googleusercontent.com/aida-public/AB6AXuC2_1OXJzegiK2F_3geu8XCkwRx5fgtVYyT7hw3dbzosU834WGNrn0GymrBSLie3PLX-nOM3zE2CMCN3MdiWU7GyewCMNZuZlTtdOfLzv-GWar81dRXOva4vCyRQs-mxtM-p1Rw8uDOjyH1X81FQgwz8Y2zN-Mw7ejYOOlT8hE-i0vSmMn7vokNWBozL86oJr6XWkZZ4MmpFzD2dQL4kTuCEgvN33q2PE_VC4rV1blspMeWc1LxxkAn1kwa4CYefwLFRDyM6Kgs0A"
        },
        {
            id: 4,
            name: "Fedha, Uchumi na Mipango",
            image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCppQLM4k6OHp36uMmokjMvZne2P_71_Pfe7jJ8XQmVz1PdbpIOoqPmm2tpltDzvJOSmG_LiZlYfe9naChQYCtdkEN1NS2Eo1KqlRqWcvldJR6H8yEt2L6v4s-ek-r5dR3Zp3m_Q6hSGkHU4DgCzTsoUREpJCbKjhfnNIB_rDDh2zPUPQYVPlvrQwaLFH0L1O0xvARuiFCuhtd0ZNTUheJQE3FPFSP3KMf8EizEgP4x2R8z-w4ZK1yxYLJ5idLQ9bwE08gwesuEow"
        },
        {
            id: 5,
            name: "Uratibu wa Huduma za Shuleni na Vyuoni",
            image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDx6eKccpV24Ps27vqIfZDPIoJDIqndvkXihKFnpWHbA9XrrUKZsv9y4YAhn2fnLZj3yIy8k_v5as9c66841_aKH5juF12KTiGfVsRndjT_khVT5qdB_rLA73mFx4YNRCXEuJK3jH1CzdgYcPmfyU3NcjoOvSpVEK6OXkfwPDI7FR0o410dTXl-QW-uIs-Y-ryKQwr_kJIWzrOneHZjjKy5f79kz0vPxnh3yxGkB57LwxxN8kdQKrYkD2cLdOFWQg4mwBewNid9Dg"
        }

    ];

    return (
        <div className="flex flex-col min-h-screen  font-display text-[#101922] dark:text-background-light">
            <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">

                <div className="bg-white dark:bg-gray-800 max-w-4xl rounded-2xl shadow-xl p-8 mb-12">
                    <h2 className="text-3xl text-center font-bold text-gray-900 dark:text-white mb-8">Idara na Vitengo vya CPCT</h2>
                    <span>
                                Kusudi la idara na vitengo:
                            </span>
                    <br></br>
                    <br></br>

                    <div className="md:flex gap-6 text-lg">
                        <div className={'flex flex-col flex-1 gap-3'}>
                            <div className="flex items-start gap-4 rounded-lg dark:bg-blue-900/20">
                                <div
                                    className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-blue-800 rounded-full flex items-center justify-center">
                                    <span className="text-white dark:text-blue-400 font-bold">i</span>
                                </div>
                                <p className="">Kwa kusudi la kuleta ufanisi katika utekelezaji wa malengo ya CPCT, Baraza litaunda idara za kitaifa na vitengo vya ofisi ya Taifa kama itakavyoonekana inahitajika na inafaa.</p>
                            </div>
                            <div className="flex items-start gap-4 rounded-lg  dark:bg-green-900/20">
                                <div
                                    className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-green-800 rounded-full flex items-center justify-center">
                                    <span className="text-white dark:text-green-400 font-bold">ii</span>
                                </div>
                                <p className="text-gray-700 dark:text-gray-300">Idara na vitengo vitakavyoundwa vitatekeleza majukumu yake kwa mujibu wa miongozo itakayotengenezwa na kupitishwa na Baraza la Maaskofu.</p>
                            </div>
                        </div>

                        <div className={'flex flex-col flex-1 gap-3 mt-4 sm:mt-auto'}>
                            <div className="flex items-start gap-4  rounded-lg  dark:bg-purple-900/20">
                                <div
                                    className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-purple-800 rounded-full flex items-center justify-center">
                                    <span className="text-white dark:text-purple-400 font-bold">iii</span>
                                </div>
                                <p className="text-gray-700 dark:text-gray-300">Miongozo ya idara na vitengo itazingatia kuwa utendaji wa kila idara na kitengo hauingilii mipango na malengo ya madhehebu na huduma wanachama.</p>
                            </div>
                            <div className="flex items-start gap-4 rounded-lg  dark:bg-orange-900/20">
                                <div
                                    className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-orange-800 rounded-full flex items-center justify-center">
                                    <span className="text-white dark:text-orange-400 font-bold">iv</span>
                                </div>
                                <p className="text-gray-700 dark:text-gray-300">Pasipo kuathiri mamlaka ya Baraza la Maaskofu ya kuunda idara na vitengo vingine kwa mujibu wa Katiba, kutakuwa na idara na vitengo vifuatavyo:</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="max-w-4xl bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 mb-8 mx-auto">
                    <h2 className="text-3xl  text-center font-bold tracking-tight text-[#101922] dark:text-background-light mb-8">
                        Idara
                    </h2>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-3">
                        {departments.slice(0, 6).map((department) => (
                            <div
                                key={department.id}
                                className="flex items-center gap-4 p-4 bg-white/50 dark:bg-background-dark/50 border border-background-dark/10 dark:border-background-light/10 rounded-lg hover:shadow-lg hover:border-primary/50 dark:hover:border-primary/50 transition-all duration-300"
                            >
                                <img
                                    alt={`${department.name} department icon`}
                                    className="w-12 h-12 rounded-lg object-cover"
                                    src={department.image}
                                />
                                <h3 className="text-lg text-[#101922] dark:text-background-light">
                                    {department.name}
                                </h3>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="max-w-4xl bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 mb-12 mx-auto">
                    <h2 className="text-3xl  text-center font-bold tracking-tight text-[#101922] dark:text-background-light mb-8">
                        Vitengo
                    </h2>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-3">
                        {vitengo.slice(0, 6).map((department) => (
                            <div
                                key={department.id}
                                className="flex items-center gap-4 p-4 bg-white/50 dark:bg-background-dark/50 border border-background-dark/10 dark:border-background-light/10 rounded-lg hover:shadow-lg hover:border-primary/50 dark:hover:border-primary/50 transition-all duration-300"
                            >
                                <img
                                    alt={`${department.name} department icon`}
                                    className="w-12 h-12 rounded-lg object-cover"
                                    src={department.image}
                                />
                                <h3 className="text-lg  text-[#101922] dark:text-background-light">
                                    {department.name}
                                </h3>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Idara;